export const FACEBOOK_URL = "https://www.facebook.com/getspotlessnow";
export const INSTAGRAM_URL = "https://www.instagram.com/getspotlessnow/";
export const YOUTUBE_URL = "https://www.youtube.com/@SpotlessMobileDetailing";
export const TIKTOK_URL = "https://www.tiktok.com/@getspotlessnow";

export const BASE_URL = "https://getspotlessnc.com";

export const BOOKING_URL =
  "https://book.squareup.com/appointments/t25pubegvfjcw1/location/LDK47FK18Z9GH/services";

export const GOOGLE_MAPS_URL =
  "https://www.google.com/maps/d/u/3/embed?mid=1mtj3lKkRzf72krGSLKIV9mUKzDWvHW0&ehbc=2E312F&noprof=1";

export const GOOGLE_REVIEWS_URL = "https://www.google.com/maps/place/Spotless+Auto+Detailing:+Mobile+Car+Detailing+%26+Ceramic+Coating/@35.7156926,-78.9257241,13z/data=!4m12!1m2!2m1!1smobile+detailing!3m8!1s0x2e3895aef2810335:0xf9d7593217fd03a9!8m2!3d35.723543!4d-78.8839443!9m1!1b1!15sChBtb2JpbGUgZGV0YWlsaW5nWhIiEG1vYmlsZSBkZXRhaWxpbmeSARVjYXJfZGV0YWlsaW5nX3NlcnZpY2XgAQA!16s%2Fg%2F11wh63g393?entry=ttu&g_ep=EgoyMDI1MDIxOS4xIKXMDSoASAFQAw%3D%3D#:~:text=Overview-,Reviews,-About";
export const LEAVE_REVIEW_URL = "https://g.page/r/CakD_RcyWdf5EBM/review";
export const GOOGLE_BUSINESS_URL =
  "https://www.google.com/maps/place/Spotless+Detailing:+Mobile+Auto+Detailing+%26+Ceramic+Coating/@35.723543,-78.8839443,17z/data=!4m16!1m9!3m8!1s0x2e3895aef2810335:0xf9d7593217fd03a9!2sSpotless+Detailing:+Mobile+Auto+Detailing+%26+Ceramic+Coating!8m2!3d35.723543!4d-78.8839443!9m1!1b1!16s%2Fg%2F11wh63g393!3m5!1s0x2e3895aef2810335:0xf9d7593217fd03a9!8m2!3d35.723543!4d-78.8839443!16s%2Fg%2F11wh63g393?hl=en&entry=ttu&g_ep=EgoyMDI0MTEyNC4xIKXMDSoASAFQAw%3D%3D";

export const CONTACT_PATH = "/contact";
export const GIFT_CARDS_PATH =
  "https://app.squareup.com/gift/MLZ25VXQNPSCW/order";
export const FAQS_PATH = "/faq";
export const SERVICES_PATH = "/services";
export const ABOUT_PATH = "/about";
export const HOME_PATH = "/";
export const BOOKING_PAGE_PATH = "/booking";
export const BOOKING_PATH = "/booking";
export const MEMBERSHIP_PATH = "/membership";
export const MOBILE_DETAILING_PATH = "/mobile-detailing";
export const GALLERY_PATH = "/gallery";
export const REVIEWS_PATH = "/reviews";
export const AUTO_DETAILING_PATH = "/auto-detailing";
export const MOBILE_INTERIOR_DETAILING_PATH = "/mobile-interior-detailing";
export const MOBILE_INTERIOR_DETAILING_BOOKING_PATH =
  "/mobile-interior-detailing#booking";
export const MOBILE_EXTERIOR_DETAILING_PATH = "/mobile-exterior-detailing";
export const MOBILE_EXTERIOR_DETAILING_BOOKING_PATH =
  "/mobile-exterior-detailing#booking";
export const MOBILE_FULL_DETAILING_PATH = "/mobile-full-detailing";
export const MOBILE_FULL_DETAILING_BOOKING_PATH =
  "/mobile-full-detailing#booking";
export const THANK_YOU_PATH = "/thank-you";


export const EXPRESS_EXTERIOR_PATH = "/express-exterior";
export const ULTIMATE_EXTERIOR_PATH = "/ultimate-exterior";

export const EXPRESS_INTERIOR_PATH = "/express-interior";
export const ULTIMATE_INTERIOR_PATH = "/ultimate-interior";

export const MAINTENANCE_FULL_DETAILING_PATH = "/maintenance-full-detailing";
export const ULTIMATE_FULL_DETAILING_PATH = "/ultimate-full-detailing";
export const EXPRESS_FULL_DETAILING_PATH = "/express-full-detailing";

export const CERAMIC_COATING_PATH = "/ceramic-coating";

export const APEX_PATH = "/apex";
export const RALEIGH_PATH = "/raleigh";
export const CARY_PATH = "/cary";
export const HOLLY_SPRINGS_PATH = "/holly-springs";
export const MORRISVILLE_PATH = "/morrisville";
export const KNIGHTDALE_PATH = "/knightdale";
export const GARNER_PATH = "/garner";

export const CALL_NUMBER = "tel:9199060099";
export const TEXT_NUMBER = "sms:9199060099";
